import React from 'react';
import { Modal, Input, Form, Button, message } from 'antd';
import { api, onPost, onGet } from '../../core/api3';
import { hex_md5 } from '../../utils/md5';
import JSEncrypt from 'jsencrypt';

class LoginView extends React.Component {

    constructor() {
        super();
        this.state = {
            username: '',
            password: ''
        }
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.props.form.validateFieldsAndScroll((error, fields) => {
            if (error) {
                return;
            }
            onGet(api.getRSAPublicKey.url).then(response => {
                if (response === undefined) {
                    return;
                }
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(response);
                let passwordEncrypt = encodeURIComponent(encrypt.encrypt(hex_md5(fields.password)));
                onPost(api.login.url, api.login.params(fields.username, passwordEncrypt)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    localStorage.setItem('token', response);
                    message.success('登录成功');
                    this.props.onModalFinish();
                    window.location.reload();
                });
            })
        });
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        return (
            <Modal title="登录" visible={true} okText="确定" okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                <Form>
                    <Form.Item {...formItemLayout} label="用户名">
                        {this.props.form.getFieldDecorator('username', {
                            rules: [{ required: true, message: '请输入用户名' }]
                        })(
                            <Input placeholder="请输入用户名" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="密码">
                        {this.props.form.getFieldDecorator('password', {
                            rules: [{ required: true, message: '请输入密码' }]
                        })(
                            <Input type="password" placeholder="请输入密码" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                        <Button type="primary" onClick={this.onClick}>登录</Button>
                    </Form.Item>
                </Form>
            </ Modal>
        );
    }

}

const LoginModal = Form.create()(LoginView);
export default LoginModal;



// WEBPACK FOOTER //
// ./src/page/jsx/LoginModal.jsx